var _style, _circle, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F0F0F0;}\r\n\t.st1{fill:#0052B4;}\r\n\t.st2{fill:#D80027;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.9,100.1c-20.1,26.2-35.3,56.3-44.1,89.1H142L52.9,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M503.2,189.2c-8.8-32.8-24-62.9-44.1-89.1L370,189.2H503.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,322.8c8.8,32.8,24,62.9,44.1,89.1l89.1-89.1H8.8L8.8,322.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.9,52.9c-26.2-20.1-56.3-35.3-89.1-44.1V142L411.9,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.1,459.1c26.2,20.1,56.3,35.3,89.1,44.1V370L100.1,459.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.2,8.8c-32.8,8.8-62.9,24-89.1,44.1l89.1,89.1V8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.8,503.2c32.8-8.8,62.9-24,89.1-44.1L322.8,370L322.8,503.2L322.8,503.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370,322.8l89.1,89.1c20.1-26.2,35.3-56.3,44.1-89.1H370z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M509.8,222.6H289.4h0V2.2C278.5,0.7,267.3,0,256,0c-11.3,0-22.5,0.7-33.4,2.2v220.4v0H2.2 C0.7,233.5,0,244.7,0,256c0,11.3,0.7,22.5,2.2,33.4h220.4h0v220.4c10.9,1.4,22.1,2.2,33.4,2.2c11.3,0,22.5-0.7,33.4-2.2V289.4v0 h220.4c1.4-10.9,2.2-22.1,2.2-33.4C512,244.7,511.3,233.5,509.8,222.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M322.8,322.8L322.8,322.8L437,437c5.3-5.3,10.3-10.7,15-16.4l-97.8-97.8L322.8,322.8L322.8,322.8L322.8,322.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.2,322.8L189.2,322.8L75,437c5.3,5.3,10.7,10.3,16.4,15l97.8-97.8L189.2,322.8L189.2,322.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.2,189.2L189.2,189.2L75,75c-5.3,5.3-10.3,10.7-15,16.4l97.8,97.8L189.2,189.2L189.2,189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M322.8,189.2L322.8,189.2L437,75c-5.3-5.3-10.7-10.3-16.4-15l-97.8,97.8V189.2z"
  }))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2134,
    height: 2134,
    xlinkHref: "8487CE73.jpg",
    transform: "matrix(0.24 0 0 0.24 -8.052099e-02 -8.050418e-02)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.933ca149ab24c61635b34c56d2c4d7a5.svg";
export { ForwardRef as ReactComponent };